<script>
    import EmbeddableProductOffers from "./EmbeddableComponents/EmbeddableProductOffers.svelte";

    export let config;
    export let mid;
    export let mtype;
    export let mname;

    console.log(mtype)
</script>

<article class="px-0 py-2 mb-3 bg-transparent">

    <div class="mb-4 pb-0 text-center">
{#if mtype == "TYPE_PRODUCT_OFFERS"}
    <h2 class="mb-5 site-header">
        {@html mname}</h2>
    <EmbeddableProductOffers mid={mid} {config} />
{/if}

    </div>
</article>
